import { intl, mathService } from '@approvalmax/utils';
import { useSelector } from 'modules/react-redux';
import { memo, useMemo } from 'react';

import { getQBooksContext } from '../../../../../../selectors/qbooks';
import { calculateAmounts } from '../../../QBooksJournalEntryRequestForm.utils';
import { messages } from './JournalEntryFooter.messages';
import { AmountLabel, AmountValue, InfoTable, OutByValue, Separator, Wrapper } from './JournalEntryFooter.styles';
import { JournalEntryFooterProps } from './JournalEntryFooter.types';

/**
 * @deprecated Use redesigned component {@link JournalEntrySummary}
 */
const JournalEntryFooter = memo<JournalEntryFooterProps>((props) => {
    const { lines, currency, lineAmountType, date } = props;

    const qbooksContext = useSelector(getQBooksContext);

    const { debitSubTotal, creditSubTotal, debitTotal, creditTotal, taxes } = useMemo(() => {
        return calculateAmounts(lines, lineAmountType, date, qbooksContext);
    }, [lines, lineAmountType, date, qbooksContext]);

    return (
        <Wrapper>
            <InfoTable>
                <thead>
                    <tr>
                        <td />

                        <AmountLabel>{`${messages.debitTitle} (${currency?.id})`}</AmountLabel>

                        <AmountLabel>{`${messages.creditTitle} (${currency?.id})`}</AmountLabel>
                    </tr>
                </thead>

                <tbody>
                    {Object.keys(taxes).length > 0 && (
                        <tr>
                            <AmountLabel>{messages.subtotalTitle}</AmountLabel>

                            <AmountValue>{intl.formatNumber(debitSubTotal, 2)}</AmountValue>

                            <AmountValue>{intl.formatNumber(creditSubTotal, 2)}</AmountValue>
                        </tr>
                    )}

                    {Object.keys(taxes).map((tax) => (
                        <tr key={tax}>
                            <AmountLabel>{taxes[tax].taxName}</AmountLabel>

                            <AmountValue>{intl.formatNumber(taxes[tax].debit, 2)}</AmountValue>

                            <AmountValue>{intl.formatNumber(taxes[tax].credit, 2)}</AmountValue>
                        </tr>
                    ))}

                    <tr>
                        <AmountLabel>{messages.totalTitle}</AmountLabel>

                        <AmountValue>{intl.formatNumber(debitTotal, 2)}</AmountValue>

                        <AmountValue>{intl.formatNumber(creditTotal, 2)}</AmountValue>
                    </tr>

                    {debitTotal !== creditTotal && (
                        <>
                            <tr>
                                <td colSpan={3}>
                                    <Separator />
                                </td>
                            </tr>

                            <tr>
                                <td />

                                <AmountLabel>{messages.totalIsOutBy}</AmountLabel>

                                <OutByValue>
                                    {intl.formatNumber(mathService.subtract(debitTotal, creditTotal), 2)}
                                </OutByValue>
                            </tr>
                        </>
                    )}
                </tbody>
            </InfoTable>
        </Wrapper>
    );
});

export default JournalEntryFooter;
